<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M20 2H4a2 2 0 00-2 2v18l4-4h14a2 2 0 002-2V4a2 2 0 00-2-2M6 9h12v2H6m8 3H6v-2h8m4-4H6V6h12"/>
    </svg>
</template>

<script>
export default {
    name: 'MessageTextIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
